var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMigrateUserBanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "art"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4740_57403)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24.3685,
    cy: 23.7904,
    r: 16.7904,
    fill: "#FCD800"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24.3004 25.9729H25.183V18.9867H24.3004V25.9718V25.9729ZM24.3059 27.9498H25.1874V27.0848H24.3059V27.9498ZM34.2836 28.6243L26.0303 14.9106L25.5172 15.7626L33.5235 29.0649C33.6415 29.2608 33.5654 29.4341 33.5268 29.5001C33.4882 29.5661 33.3745 29.7188 33.144 29.7188H16.3493C16.1176 29.7188 16.004 29.5661 15.9665 29.5001C15.929 29.4341 15.8517 29.2608 15.9698 29.0649L25.0042 14.0608C24.9204 14.0445 24.8343 14.0337 24.7472 14.0337C24.2739 14.0337 23.848 14.2719 23.6075 14.6724L15.2096 28.6243C14.9647 29.0313 14.9614 29.5185 15.1997 29.9288C15.438 30.3391 15.8683 30.5838 16.3493 30.5838H33.144C33.625 30.5838 34.0552 30.3391 34.2935 29.9288C34.5318 29.5185 34.5285 29.0313 34.2836 28.6243Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4740_57403",
    x: 1.66399,
    y: 1.08587,
    width: 45.4103,
    height: 45.4091,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.95707
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4740_57403"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4740_57403",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMigrateUserBanner);
export default __webpack_public_path__ + "static/media/migrate-user-banner.55714bb7f1b001f8be531180d2e267e7.svg";
export { ForwardRef as ReactComponent };